<template>
    <CButton
        :block="block"
        :color="color"
        :disabled="disabled"
        :type="type"
        :title="title"
        class="ml-2 button shadow d-flex close-button"
        @click="$emit('click')"
    >
        <span class="button__icon">
            <CIcon :content="$options.icons.cilX" />
        </span>
        <span class="button__text">
            <slot>
                {{ $t("close") }}
            </slot>
        </span>
    </CButton>
</template>

<script>
import { cilPlus, cilX } from "@coreui/icons";
export default {
    name: "ButtonClose",
    icons: {
        cilPlus,
        cilX,
    },
    props: {
        block: {
            type: Boolean,
            default: false,
        },
        color: {
            default: "secondary",
            type: String,
        },
        disabled: Boolean,
        type: String,
        title: {
            type:String
        },
    },
};
</script>
<style lang="scss">
</style>